/**
 * @generated SignedSource<<a7cf25b3ac41bb953fd91311af017277>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SkillLevelDropdown_company$data = {
  readonly skillLevels: ReadonlyArray<{
    readonly id: string;
    readonly level: number | null;
    readonly description: string | null;
  } | null> | null;
  readonly " $fragmentType": "SkillLevelDropdown_company";
};
export type SkillLevelDropdown_company$key = {
  readonly " $data"?: SkillLevelDropdown_company$data;
  readonly " $fragmentSpreads": FragmentRefs<"SkillLevelDropdown_company">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SkillLevelDropdown_company",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SkillLevel",
      "kind": "LinkedField",
      "name": "skillLevels",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "level",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Company",
  "abstractKey": null
};

(node as any).hash = "cb98250d357f9d3e31120740082b39a0";

export default node;
